import { render, staticRenderFns } from "./CaseReviewView.vue?vue&type=template&id=c906ceb4&scoped=true&"
import script from "./CaseReviewView.vue?vue&type=script&lang=js&"
export * from "./CaseReviewView.vue?vue&type=script&lang=js&"
import style0 from "./CaseReviewView.vue?vue&type=style&index=0&id=c906ceb4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c906ceb4",
  null
  
)

export default component.exports